"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleAclCategoryActionMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const roles_entity_1 = require("./roles.entity");
const acl_category_action_map_entity_1 = require("./acl-category-action-map.entity");
let RoleAclCategoryActionMap = class RoleAclCategoryActionMap {
    constructor(id, role, aclCategoryActionMap, createdBy, updatedBy) {
        this.id = id;
        this.role = role;
        this.aclCategoryActionMap = aclCategoryActionMap;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.RoleAclCategoryActionMap = RoleAclCategoryActionMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], RoleAclCategoryActionMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => roles_entity_1.Role, { nullable: false, onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "role_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof roles_entity_1.Role !== "undefined" && roles_entity_1.Role) === "function" ? _c : Object)
], RoleAclCategoryActionMap.prototype, "role", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => acl_category_action_map_entity_1.AclCategoryActionMap, {
        nullable: false,
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "acl_category_action_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof acl_category_action_map_entity_1.AclCategoryActionMap !== "undefined" && acl_category_action_map_entity_1.AclCategoryActionMap) === "function" ? _d : Object)
], RoleAclCategoryActionMap.prototype, "aclCategoryActionMap", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], RoleAclCategoryActionMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], RoleAclCategoryActionMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], RoleAclCategoryActionMap.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], RoleAclCategoryActionMap.prototype, "updatedBy", void 0);
exports.RoleAclCategoryActionMap = RoleAclCategoryActionMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("role_acl_category_action_map"),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_a = typeof roles_entity_1.Role !== "undefined" && roles_entity_1.Role) === "function" ? _a : Object, typeof (_b = typeof acl_category_action_map_entity_1.AclCategoryActionMap !== "undefined" && acl_category_action_map_entity_1.AclCategoryActionMap) === "function" ? _b : Object, String, String])
], RoleAclCategoryActionMap);
